import React, { useEffect, useState, useMemo } from 'react'
import { useUcForm } from '../../../hooks/useUcForm';
import { postNySakDebitorWithAI, getPDFInfo, clearPdfInfo, clearDifferentDebitor, startUploadFakturaWithAI, startEditFakturaWithAI, startDeleteFakturaWithAI, startClearFaktura, startFinalizeFakturaWithAI } from '../../../reduxStore/newCase/newCaseActions';
import { GetFormValidators, GetFormValidatorsNew } from './debitorFormWithAIValidators'
import { useNotFinishedtModal } from '../modals/useNotFinishedModal';
import { useNavigate } from 'react-router-dom';
import { useDifferentDebitorModal } from '../modals/useDifferentDebitorModal';

const useDebitorFormWithAI = (state, dispatch, showToast, localeMessages) => {

    const [preCaseId, setPreCaseId] = useState(null);
        
    const fakturaInfo = state.pdfInfo;
    // Sjekk på state for å inialisere formverdier
    let formValues = {
        requiredDebtorName: '',
        debtorType: '',
        debtorNo: '',
        customerType: '',
        produktType: state.defaultProduct ? state.defaultProduct : '',
        referanseNummer: '',
        requiredFirstName: '',
        requiredBirthDate: '',
        requiredBirthNumber: '',
        requiredDebtorIdentificationNumber: '',
        invoiceLineList: '',
        requiredLastName: '',
        requiredPostalAddress: '',
        requiredStreetAddress: '',
        requiredPostalCode: '',
        requiredPostalPlace: '',
        requiredEmail: '',
        requiredPhone: '',
        requiredCountryCode: '',
        caseMessage: '',

        lineNo: '',
        requiredFakturanummer: '',
        requiredKid: '',
        requiredFakturatekst: '',
        requiredForfallsdato: '',
        requiredFakturadato: '',
        valuta: 'NOK',
        requiredBelop: '', 
    }

    let privatDebitorFormValues = [
        'debtorType',
        'customerType',
        'produktType',
        'referanseNummer',
        'requiredFirstName',
        'requiredBirthDate',
        'requiredBirthNumber',
        'invoiceLineList',
        'requiredLastName', 
        'requiredPostalAddress', 
        'requiredStreetAddress', 
        'requiredPostalCode', 
        'requiredPostalPlace', 
        'requiredEmail', 
        'requiredPhone', 
        'requiredCountryCode',
        'caseMessage'
    ];

    let næringDebitorFormValues = [
        'requiredDebtorName',
        'debtorType',
        'debtorNo',
        'customerType',
        'produktType',
        'referanseNummer',
        'requiredDebtorIdentificationNumber',
        'invoiceLineList',
        'requiredPostalAddress', 
        'requiredStreetAddress', 
        'requiredPostalCode', 
        'requiredPostalPlace', 
        'requiredEmail', 
        'requiredPhone', 
        'requiredCountryCode',
        'caseMessage'
    ];

    let fakturaFormValues = [
        'lineNo',
        'requiredFakturanummer',
        'requiredKid',
        'requiredFakturatekst',
        'requiredForfallsdato',
        'requiredFakturadato',
        'valuta',
        'requiredBelop'
    ];

    const formatDate = d => {
        if ((d) && (d.length >= 20)) {
            return `${d.substring(8, 10)}.${d.substring(5, 7)}.${d.substring(0, 4)}`
        }
        return ''
    }

    // -----------------------------------------------------------------
    // PDF Faktura for avlesning og opplasting av fil som vedlegg til faktura
    // -----------------------------------------------------------------

    const [selectedPdfFaktura, setSelectedPdfFaktura] = useState()
    const [pdfUrl, setPdfUrl] = useState(null);
    const filePdfFakturaRef = React.useRef();

    const [selectedUploadFile, setSelectedUploadFile] = useState()
    const fileUploadRef = React.useRef();

    const onPdfFakturaChange = (event) => {
        const file = event.target.files[0];
        
        if (!file) {
          console.log("Ingen fil valgt");
          return;
        }
        
        if (file.type !== 'application/pdf') {
          alert("Ugyldig fil");
          return;
        }

        const filesArray = Array.from(event.target.files);
        const url = URL.createObjectURL(file);
      
        setPdfUrl(url);
        setSelectedPdfFaktura(filesArray);
      
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64File = e.target.result;
          const base64 = base64File.split(',')[1];
      
          postPDFInfo(file.name, base64, url, filesArray);
        };
      
        reader.onerror = (error) => {
          console.error("Error reading file:", error);
        };
        reader.readAsDataURL(file);
    };

    const onUploadFileChange = event => {
        setSelectedUploadFile(event.target.files)
    };

    // -----------------------------------------------------------------
    // Sett verdier fra avlesningen
    // -----------------------------------------------------------------

    const setFieldsFromPDF = (fakturaInfo) => { 
        // Sett alle felter når bruker velger den første fakturaen
        if (fakturaInfo && !state.debitorIsSet) {
            setField('produktType', state.defaultProduct ? state.defaultProduct : '')            
            setField('referanseNummer', fakturaInfo?.debtorCustomerNumber || '')
            // Debitorinfo
            if (fakturaInfo.customerType === 'N') 
            {            
                setField('customerType', 'Næring')  
                setField('debtorType', 'Næring')          
                setField ('requiredDebtorIdentificationNumber', '')
                setField ('requiredDebtorName', fakturaInfo.companyName)
            }  
            else {                  
                setField('customerType', 'Privat')
                setField('debtorType', 'Privat')
                setField ('requiredBirthDate', '')
                setField ('requiredBirthNumber', '')
            }    
            if (fakturaInfo.kosAddressList) {
                if (fakturaInfo.kosAddressList[0].addressType === 'STREET_ADDRESS') {
                    setField ('requiredStreetAddress', fakturaInfo.kosAddressList[0].addressLine)
                    setField ('requiredPostalAddress', fakturaInfo.kosAddressList[0].addressLine)
                } else {
                    setField ('requiredStreetAddress', '')
                    setField ('requiredPostalAddress', fakturaInfo.kosAddressList[0].addressLine)
                }
                setField ('requiredPostalCode', fakturaInfo.kosAddressList[0].postalCode)
                setField ('requiredPostalPlace', fakturaInfo.kosAddressList[0].postalPlace)
                setField ('requiredCountryCode', fakturaInfo.kosAddressList[0].country)
            }            
            setField ('requiredFirstName', fakturaInfo.firstName)
            setField ('requiredLastName', fakturaInfo.lastName)
            setField ('debtorNo', '')
            setField ('requiredEmail', '')
            setField ('requiredPhone', '')
            setField ('caseMessage', '')

            // FakturaInfo
            if (fakturaInfo.kosinvoiceLineList) {
                setField ('requiredKid', onlyNumbersOrEmpty(fakturaInfo.kosinvoiceLineList[0].customerInvoiceNumber))
                setField ('requiredFakturadato', formatDate(fakturaInfo.kosinvoiceLineList[0].invoiceDate))
                setField ('requiredForfallsdato', formatDate(fakturaInfo.kosinvoiceLineList[0].dueDate))
                setField ('requiredBelop', convertDotToComma(fakturaInfo.kosinvoiceLineList[0].invoiceAmount))
                setField ('requiredFakturanummer', fakturaInfo.kosinvoiceLineList[0].invoiceNumber)
                if (fakturaInfo.kosinvoiceLineList[0].specification && fakturaInfo.kosinvoiceLineList[0].specification.length > 29) {
                    setField ('requiredFakturatekst', fakturaInfo.kosinvoiceLineList[0].specification.substring(0,29))
                } else {
                    setField ('requiredFakturatekst', fakturaInfo.kosinvoiceLineList[0].specification)
                }
                setField ('valuta', 'NOK')
            }
        // Sett kun faktura-info om ikke første faktura
        } else if (fakturaInfo && state.debitorIsSet) {
            setField ('requiredKid', onlyNumbersOrEmpty(fakturaInfo.kosinvoiceLineList[0].customerInvoiceNumber))
            setField ('requiredFakturadato', formatDate(fakturaInfo.kosinvoiceLineList[0].invoiceDate))
            setField ('requiredForfallsdato', formatDate(fakturaInfo.kosinvoiceLineList[0].dueDate))
            setField ('requiredBelop', convertDotToComma(fakturaInfo.kosinvoiceLineList[0].invoiceAmount))
            setField ('requiredFakturanummer', fakturaInfo.kosinvoiceLineList[0].invoiceNumber)
            if (fakturaInfo.kosinvoiceLineList[0].specification && fakturaInfo.kosinvoiceLineList[0].specification.length > 29) {
                setField ('requiredFakturatekst', fakturaInfo.kosinvoiceLineList[0].specification.substring(0,29))
            } else {
                setField ('requiredFakturatekst', fakturaInfo.kosinvoiceLineList[0].specification)
            }
            setField ('valuta', 'NOK')
        }
        // Setter opplastet pdf som vedlegg i fakturainfo, kan overstyres 
        setSelectedUploadFile(state.fileInfo)
    }

    useEffect(() => {
    if (fakturaInfo && fakturaInfo !== undefined) {
        setFieldsFromPDF(fakturaInfo);
    }
    }, [fakturaInfo]);


    // -----------------------------------------------------------------
    // Dropdowns
    // -----------------------------------------------------------------

    const produktOptions = () => {
        return (
            <>
                <option value="">Velg</option>
                <option value="Purring">Inkassovarsel</option>
                <option value="Inkasso">Inkasso</option>
            </>
        )
    }

    const debtorTypeOptions = () => {
        return (
            <>
                <option value="">Velg</option>
                <option value="Næring">Næring</option>
                <option value="Privat">Privat</option>
            </>
        )
    }

    const currencyOptions = () => {
        return (
            <>
                <option key={-1} value={""}>Velg valuta</option>
                {state.currencyList.map((item, i) => (
                    <option key={i} value={item.countryCode}>{item.countryCode}</option>
                ))}
            </>
        )
    }

    // -----------------------------------------------------------------
    // start: Sett opp en ucForm med formvalues og validators
    // -----------------------------------------------------------------

    const [extraErrors, setExtraErrors] = useState({})
    const [errorMessage, setErrorMessage] = useState('')

    let formValidators = GetFormValidatorsNew(localeMessages)
        
    const {
        handleChange, handleCheckboxChange, setField, handleMultiSelectChange,
        formState, validateField, validateAll, errorMessages,
        formIsValid, validatorsState, clearField
    } = useUcForm(formValues, formValidators)
    
    // Lager to individuelle hasErrors for å bedre håndtere valideringer mellom debitor og faktura
    const hasErrorsDebitor = useMemo(() => {
        let debitorFormValues = []
        if (formState.customerType === 'Næring') {
            debitorFormValues = næringDebitorFormValues;
        } else if (formState.customerType === 'Privat') {
            debitorFormValues = privatDebitorFormValues;
        }
        const errorsForForm1 = Object.keys(errorMessages)
        .filter(key => debitorFormValues.includes(key))
        .map(key => errorMessages[key])
        .concat(
            Object.keys(extraErrors)
            .filter(key => debitorFormValues.includes(key))
            .map(key => extraErrors[key])
        );
        
        return errorsForForm1.some(x => x !== null && x !== '');
    }, [errorMessages, extraErrors]);

    const hasErrorsFaktura = useMemo(() => {
        const errorsForForm1 = Object.keys(errorMessages)
        .filter(key => fakturaFormValues.includes(key))
        .map(key => errorMessages[key])
        .concat(
            Object.keys(extraErrors)
            .filter(key => fakturaFormValues.includes(key))
            .map(key => extraErrors[key])
        );
        
        return errorsForForm1.some(x => x !== null && x !== '');
    }, [errorMessages, extraErrors]);

    const handlePnrChange = (e) => {

        if (e.target.value.length === 4) {
            let res = state.postalList.filter(x => x.postalCode === e.target.value)
            if (res.length === 1) {
                setField('postalPlace', res[0].postalPlace)
            }
            console.log(res)
        }
        handleChange(e)
    }


    // -----------------------------------------------------------------
    // Hjelpere
    // -----------------------------------------------------------------

    const convertDotToComma = d => {
        if (d && d !== undefined) {
            return d.toString().replace('.', ',');
        }
        return ''
    }

    function onlyNumbersOrEmpty(value) {
        if (!value) return '';
        const strValue = value.toString();
        
        // verdien skal kun inneholde tall ellers tom string.
        return /^\d+$/.test(strValue) ? strValue : '';
    }

    const getBirthDateOrFnr = (formState) => {
        if (formState.requiredBirthNumber) {
            return formState.requiredBirthNumber.replace(/\s+/g, '')
        }
        else if (formState.requiredBirthDate) {
            return formState.requiredBirthDate.replaceAll('.', '')
        } else {
            return ''
        }
    }

    const stripSpaces = (inString) => {
        if (inString) {
            let result = inString.replace(/\s+/g, '') 
            return result
        }
        return ''
    }

    const convertDateFormat = (dateStr) => {
        if (!dateStr) return '';
        
        let separator = '';
        if (dateStr.includes('.')) {
          separator = '.';
        } else if (dateStr.includes('-')) {
          separator = '-';
        } else {
          return '';
        }
        
        const parts = dateStr.split(separator);
        if (parts.length !== 3) return '';
        
        const [day, month, year] = parts;
        return `${year}-${month}-${day}`;
      };

    const convertDateFormatToDot = (dateStr) => {
        if (!dateStr) return '';
        const parts = dateStr.split('-');
        if (parts.length !== 3) return '';
        const [year, month, day] = parts;
        
        return `${day}.${month}.${year}`;
    }

    // const formatDecimal = d => d.toString().replace(/ /g, '').replace(/,/, '.')
    const formatDecimal = d => parseFloat(d.toString().replace(/ /g, '').replace(/,/, '.'))

    // -----------------------------------------------------------------
    // Start: når bruker trykker på Legg til faktura knapp
    // -----------------------------------------------------------------

    const submitForm = async () => {
        // Gå rett til opplasting av faktura om preCaseId finnes
        if (preCaseId) {
            uploadFaktura(preCaseId, true);
        } else {
    
            // Valider alle
            let formDontValidate = validateAll();

            // Sjekk felter som ikke valideres på cursor
            setExtraErrors({})

            // Test på om det finnes error
            if (formDontValidate) {
                console.log('cannot be submitted')
            } else {
                console.log('Canbesubmitted')

                // Her må du opprette ny debitor, send inn dispatch vis fakturaslist
                let formData = {};
                if (formState.customerType === 'Næring') {
                    formData = {
                        CreditorNo: state.kreditorId,
                        DepartmentId: -1,
                        debtorName: formState.requiredDebtorName,
                        debtorNo: stripSpaces(formState.requiredDebtorIdentificationNumber),
                        debtorType: formState.customerType,
                        produktType: formState.produktType,
                        referanseNummer: formState.referanseNummer,
                        firstName: '',
                        birthDate: '',
                        birthNumber: '',
                        debtorIdentificationNumber: formState.requiredDebtorIdentificationNumber,
                        invoiceLineList: '',
                        lastName: '',
                        postalAddress: formState.requiredPostalAddress,
                        streetAddress: formState.requiredStreetAddress,
                        postalCode: formState.requiredPostalCode,
                        postalPlace: formState.requiredPostalPlace,
                        email: formState.requiredEmail,
                        phone: formState.requiredPhone,
                        countryCode: formState.requiredCountryCode,
                        caseMessage: formState.caseMessage,
                        channelId: 11,     // channelId er alltid 11 når vi bruker AI
                    }
                } else {
                    formData = {
                        CreditorNo: state.kreditorId,
                        DepartmentId: -1,
                        debtorName: '',
                        debtorNo: '',
                        debtorType: formState.customerType,
                        produktType: formState.produktType,
                        referanseNummer: formState.referanseNummer,
                        firstName: formState.requiredFirstName,
                        birthDate: getBirthDateOrFnr(formState),
                        birthNumber: getBirthDateOrFnr(formState),
                        debtorIdentificationNumber: '',
                        invoiceLineList: '',
                        lastName: formState.requiredLastName,
                        postalAddress: formState.requiredPostalAddress,
                        streetAddress: formState.requiredStreetAddress,
                        postalCode: formState.requiredPostalCode,
                        postalPlace: formState.requiredPostalPlace,
                        email: formState.requiredEmail,
                        phone: formState.requiredPhone,
                        countryCode: formState.requiredCountryCode,
                        caseMessage: formState.caseMessage,
                        channelId: 11,     // channelId er alltid 11 når vi bruker AI
                    }
                }
                 
            
                const result = await dispatch(postNySakDebitorWithAI(formData, true, localeMessages))
                if (result) {
                    setPreCaseId(result)
                    uploadFaktura(result, false);
                } else {
                    console.log('Abort ship.')
                }
            }
        }
    }

    const uploadFaktura = (preCaseId, showLoading) => {
        let formDontValidate = validateAll();

        // Sjekk felter som ikke valideres på cursor
        setExtraErrors({})

        // Test på om det finnes error
        if (formDontValidate) {
            console.log('FakturaUpload: Cannot be submitted')
        } else {

            // Dette objektet skal til fakturalisten
            let fakturaAdded = {
                lineNo: formState.lineNo,
                fakturaNummer: formState.requiredFakturanummer,
                kid: formState.requiredKid,
                fakturaTekst: formState.requiredFakturatekst,
                forfallsDato: convertDateFormat(formState.requiredForfallsdato),
                fakturaDato: convertDateFormat(formState.requiredFakturadato),
                valuta: formState.valuta,
                belop: formatDecimal(formState.requiredBelop),
                fileName: ''
            }

            // Dette objektet skal til kos
            const formData = new FormData();

            // Update the formData object
            if (selectedUploadFile) {

                // TODO iterate all files
                Array.from(selectedUploadFile).forEach(uplfile => {
                    formData.append(
                        "files",
                        uplfile,
                        uplfile.name    
                )})
   
                // Keep track of uploaded file in redux store
                Array.from(selectedUploadFile).forEach(uplfile => {
                    if (!fakturaAdded.fileName)
                        fakturaAdded.fileName = uplfile.name    
                    else 
                        fakturaAdded.fileName += ', ' +  uplfile.name
                })
            }          

            // Sjekk om ny eller gammel sak
            let lineNo = state.lineNo

            // Dersom ny faktura, må begge objektene oppdateres
            if (!formState.lineNo) {
                lineNo = lineNo + 1
                fakturaAdded.lineNo = lineNo
                formData.append('lineNo', lineNo )
            } else {
                formData.append('lineNo', formState.lineNo)
            }

            formData.append('preCaseId', preCaseId)
            formData.append('creditorNo', state.kreditorId)
            formData.append('fakturanummer', formState.requiredFakturanummer)
            formData.append('fakturatekst', formState.requiredFakturatekst)
            formData.append('forfallsdato', convertDateFormat(formState.requiredForfallsdato))
            formData.append('kid', formState.requiredKid)
            formData.append('fakturadato', convertDateFormat(formState.requiredFakturadato))
            formData.append('valuta', formState.valuta)
            formData.append('belop', formatDecimal(formState.requiredBelop))           

            //let lLineNo = state.lineNo + 1
            let fakturaListe = []

            if (!formState.lineNo) {
                // Ny faktura                
                fakturaListe = [...state.invoices, fakturaAdded]
            } else {
                // Redigert faktura
                fakturaListe = [...state.invoices]    
                let objIndex = state.invoices.findIndex((obj => obj.lineNo === formState.lineNo));
                if (objIndex !== -1) {
                    fakturaListe[objIndex] = fakturaAdded
                }
            }            

            // TODO: Legg til antall faktura uploads på en faktura
            dispatch(startUploadFakturaWithAI(formData, fakturaListe, lineNo, showLoading, clearForm, showToast, localeMessages))
        }
    }

    // -----------------------------------------------------------------
    // Slutt: når bruker trykker på Legg til faktura knapp
    // -----------------------------------------------------------------

    // -----------------------------------------------------------------
    // start: hent eventuell rad for editering
    // -----------------------------------------------------------------

    const editFaktura = lineNo => {
        dispatch(startEditFakturaWithAI(lineNo, showToast))
        const editFaktura = state.invoices.filter((e) => e.lineNo === lineNo);

        if (editFaktura) {
            setField ('lineNo', editFaktura[0].lineNo)
            setField ('requiredKid', editFaktura[0].kid)
            setField ('requiredFakturadato', convertDateFormatToDot(editFaktura[0].fakturaDato))
            setField ('requiredForfallsdato', convertDateFormatToDot(editFaktura[0].forfallsDato))
            setField ('requiredBelop', editFaktura[0].belop.toFixed(2).replace('.', ','))
            setField ('requiredFakturanummer', editFaktura[0].fakturaNummer)
            setField ('requiredFakturatekst', editFaktura[0].fakturaTekst)
            setField ('valuta', editFaktura[0].valuta)
        }
    }

    // -----------------------------------------------------------------
    // start: slett valgt rad
    // -----------------------------------------------------------------

    const deleteFaktura = lineNo => {
        let objIndex = state.invoices.findIndex((obj => obj.lineNo === lineNo));
        let deleteObj = state.invoices[objIndex]
                
        const formData = new FormData();        
        formData.append('preCaseId', preCaseId)
        formData.append('lineNo', lineNo)
        formData.append('creditorNo', state.kreditorId)

        let fakturaListe = state.invoices.filter(obj => obj.lineNo !== lineNo)

        dispatch(startDeleteFakturaWithAI(formData, fakturaListe, clearForm, localeMessages, showToast))
    }

    // -----------------------------------------------------------------
    // Fjern all fakturainfo når Tøm-knapp trykkes på
    // -----------------------------------------------------------------

    const clearForm = () => {
        
        clearField("lineNo", "")
        clearField("requiredFakturanummer", "")
        clearField("requiredKid", "")
        clearField("requiredFakturatekst", "")
        clearField("requiredForfallsdato", "")
        clearField("requiredFakturadato", "")
        clearField("valuta", "NOK")
        clearField("requiredBelop", "")
        
        setSelectedUploadFile(null)
    
    }
    
    const emptyForm = () => dispatch(startClearFaktura())

    // -----------------------------------------------------------------
    // Send inn og gå tilbake til start
    // -----------------------------------------------------------------
    
    const finalizeFaktura = async () => {
        
        // Test på om det finnes error
        if (state.invoices.length < 1) {
            console.log('FakturaUpload: Cannot be finalized')
        } else {
            console.log('FakturaUpload Finalizing')
            
            const formData = {
                preCaseId: preCaseId,
                creditorNo: state.kreditorId
            }
            const result = await dispatch(startFinalizeFakturaWithAI(formData, true, localeMessages))
            // Scroller bruker opp til toppen, for å være hyggelig liksom
            if (result === "OK") {
                setPreCaseId(null)
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setPreCaseId(null)
            }
        }
    }

    // -----------------------------------------------------------------
    // Last opp faktura for avlesning
    // -----------------------------------------------------------------

    const postPDFInfo = (filename, fileAsBAse64, pdfUrl, fileInfo) => {
    
            let formData = new FormData();
            formData.append("customerNo", state.kreditorId);
            formData.append("pdfFilename", filename);
            formData.append("pdfFileAsBase64", fileAsBAse64);

            dispatch(getPDFInfo(formData, pdfUrl, fileInfo, true, localeMessages))
    }

    // -----------------------------------------------------------------
    // Bruker har ikke sendt inn sak og trykker Tilbake-knapp
    // -----------------------------------------------------------------

    const navigate = useNavigate();

    const handleNotFinishedBack = () => {
        dispatch(clearPdfInfo());
        navigate("/CaseNew/init");
    };

    const handleDifferentDebitorCancel = () => {
        dispatch(clearDifferentDebitor());
        setPdfUrl(null);
        setSelectedPdfFaktura(null);
    };

    const notFinishedModal = useNotFinishedtModal(localeMessages, handleNotFinishedBack)
    const differentDebitorModal = useDifferentDebitorModal(localeMessages, handleDifferentDebitorCancel)

    // -----------------------------------------------------------------
    // Returnerer verdier/funcs som skal benyttes i formen
    // -----------------------------------------------------------------

    return {
        formValues, formValidators, handleChange, formState, validateAll, setField,
        hasErrorsDebitor, hasErrorsFaktura, errorMessages, extraErrors, setExtraErrors,
        submitForm, finalizeFaktura, editFaktura, deleteFaktura, emptyForm, errorMessage, localeMessages, produktOptions, handlePnrChange,
        debtorTypeOptions, setFieldsFromPDF, currencyOptions, clearForm, notFinishedModal, differentDebitorModal,
        onPdfFakturaChange, filePdfFakturaRef, setSelectedPdfFaktura, setPdfUrl, pdfUrl, fileUploadRef, onUploadFileChange, selectedUploadFile, selectedPdfFaktura
    }
}

export default useDebitorFormWithAI